export default {
  namespaced: true,
  strict: process.env.NODE_ENV === 'development',
  state() {
    return {
      selectedHeader: {
        trainerSwornDeclarations: [],
        trainerTaxStatuses: [],
        auditTable: [],
        bankReportComparisonTable: [],
        bankReportPreview: [],
        billingStatements: [],
        AutomatedCycles: [],
        billingStatementsTrainer: [],
        billingFeeTable: [],
        cycleViewCutOffs: [],
        orTable: [],
        swornDeclarations: [],
        consoleList: []
      }
    }
  },
  mutations: {
    /**
     * Set the header.
     *
     * @param {*} state
     * @param {*} index
     */
    setselectedHeader(state, payload) {
      state.selectedHeader[payload.headerId] = payload.headers
    }
  }
}
